import { AxiosInstance } from 'axios';
import { BaseService } from 'yellowfin-ui-lib';
import { Coupon, StoreConf } from 'yf-commerce-model-ui-lib';


export class ShopService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	getShopConf(): Promise<StoreConf> {
		return this.mapResponse(this.http.get(`/ws/store/init`), StoreConf);
	}

	getCouponNewsletter(): Promise<Coupon> {
		return this.mapResponse(this.http.get(`/ws/newsletter/coupon`), Coupon);
	}

}
